<template>
	<div class="pro-content">
		<transition name="el-fade-in">
			<div id="loading" v-show="showLoading">
				<div id="loading-center">
					<div id="loading-center-absolute">
						<div class="object" id="object_one"></div>
						<div class="object" id="object_two" style="left:20px;"></div>
						<div class="object" id="object_three" style="left:40px;"></div>
						<div class="object" id="object_four" style="left:60px;"></div>
						<div class="object" id="object_five" style="left:80px;"></div>
					</div>
				</div>
			</div>
		</transition>
		<div class="container" :class="scrollNav?'proScrollTop':''">
			<div class="curr-localtion">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/' }">{{ langs.header1 }}</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/products' }">{{ langs.product1 }}</el-breadcrumb-item>
					<el-breadcrumb-item>{{ pathName }}</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
		</div>
		<div class="thumb-content" style="">
			<!-- <div class="" style="float:left; height:80px;padding:20px 0px 30px;margin-right:50px;">
				<div class="small-img" @click="clickSelectThum(0)" :class="currThum==0?'selectThum':''">
					<el-image :src="require('../../static/images/products/'+ (parseInt(proId)+1) +'/'+ (parseInt(proSeq)+1) +'/'+ (parseInt(proIndex)+1) +'/1.png')"  lazy></el-image>
				</div>
				<div class="small-img" v-if="hasThum1" @click="clickSelectThum(1)" :class="currThum==1?'selectThum':''">
					<el-image :src="require('../../static/images/products/'+ (parseInt(proId)+1) +'/'+ (parseInt(proSeq)+1) +'/'+ (parseInt(proIndex)+1) +'/1-11.png')"  lazy></el-image>
				</div>
				<div class="small-img" v-if="hasThum2" @click="clickSelectThum(2)" :class="currThum==2?'selectThum':''">
					<el-image :src="require('../../static/images/products/'+ (parseInt(proId)+1) +'/'+ (parseInt(proSeq)+1) +'/'+ (parseInt(proIndex)+1) +'/1-12.png')" lazy></el-image>
				</div>
			</div> -->

			<!--
			http://www.upus.cn:8091/Userfile/Attach/1590398248411-73100.jpg
			http://www.upus.cn:8091/Userfile/video/zh/123.mp4
			http://www.upus.cn:8091/Userfile/Otherpic/1608777423560-61937.png
			 -->
			<div class="pro-video" style="">
				<div class="">
					<video :src="'../../static/video/'+langstype+'/'+prolist[proId].children[proSeq].children[proIndex].videourl" controls width="100%" height="420px" v-if="prolist[proId].children[proSeq].children[proIndex].videourl"></video>
					<video :src="'../../static/video/'+langstype+'/123.mp4'" controls width="100%" height="420px" v-if="!prolist[proId].children[proSeq].children[proIndex].videourl"></video>
					<!--
						<video src="../../static/video/123.mp4" controls width="100%" height="100%" v-if="currlangs==0"></video>
						<video src="../../static/video/123e.mp4" controls width="100%" height="100%" v-if="currlangs==1"></video>
					-->
				</div>
				<!-- <div v-else-if="hasThum1 && currThum==1">
					<el-image :src="require('../../static/images/products/'+ (parseInt(proId)+1) +'/'+ (parseInt(proSeq)+1) +'/'+ (parseInt(proIndex)+1) +'/1-1.png')" lazy></el-image>
				</div>
				<div v-else-if="hasThum2 && currThum==2">
					<el-image :src="require('../../static/images/products/'+ (parseInt(proId)+1) +'/'+ (parseInt(proSeq)+1) +'/'+ (parseInt(proIndex)+1) +'/1-2.png')"  lazy></el-image>
				</div> -->
			</div>
		</div>
		<div class="pro-list pa-content" v-for="(item, index) in currlist" :key="index" style="text-align: center;">
			<div class="list1 wow animate__animated animate__fadeInUp animate__delay-0.3s">
				<el-image :src="require('../../static/images/products/'+ (parseInt(proId)+1) +'/'+ (parseInt(proSeq)+1) +'/'+ (parseInt(proIndex)+1) +'/'+langstype+'/'+(index+1)+'.png')" lazy></el-image>
			</div>
		</div>
	</div>
</template>

<script>
	import { WOW } from 'wowjs'
	export default{
		name: 'prodetail',
		data() {
			return {
				jeeurl: '',
				showLoading: true,
				pathName: '', //当前产品名称
				proindex: 0,

				currlist: [], // 显示的信息
				scrollNav: false,

				currlangs: 0, //0中文 1英文 2西班牙语
				langstype: 'zh', //语言
				langs: zh, //语言

				currThum: 1, //
				hasThum1: false, // 是否存在缩略图1
				hasThum2: false, // 是否存在缩略图2
				prolist: [],
				prolist1: [
					{id:1, title:'智能存取柜', desc:'', size:22, children:[
						{id:1, title:'智能快递柜', desc:'', size:4, children:[
							{id:1, title:'智能快递柜', desc:'', videourl:'101.mp4', zhsize:14, engsize:22, spsize:0, thum1:true, thum2:true},
							{id:2, title:'智能快递柜', desc:'', videourl:'101.mp4', zhsize:13, engsize:12, spsize:0, thum1:true, thum2:true},
							{id:3, title:'智能快递柜', desc:'', videourl:'101.mp4', zhsize:12, engsize:16, spsize:0, thum1:true, thum2:true},
							{id:4, title:'智能快递柜', desc:'', videourl:'101.mp4', zhsize:20, engsize:0, spsize:0, thum1:true, thum2:true},
						]},
						{id:2, title:'智能存包柜', desc:'', size:4, children:[
							{id:1, title:'智能存包柜', desc:'', videourl:'102.mp4', zhsize:11, engsize:13, spsize:0, thum1:true, thum2:true},
							{id:2, title:'智能存包柜', desc:'', videourl:'102.mp4', zhsize:11, engsize:9, spsize:0, thum1:true, thum2:true},
							{id:3, title:'智能存包柜', desc:'', videourl:'102.mp4', zhsize:8, engsize:8, spsize:0, thum1:true, thum2:true},
							{id:4, title:'智能存包柜', desc:'', videourl:'102.mp4', zhsize:21, engsize:21, spsize:0, thum1:true, thum2:false},
						]},
						{id:3, title:'智能存餐柜', desc:'', size:5, children:[
							{id:1, title:'智能存餐柜', desc:'', videourl:'1031.mp4', zhsize:17, engsize:17, spsize:0, thum1:true, thum2:true},
							{id:2, title:'智能存餐柜', desc:'', videourl:'1032.mp4', zhsize:14, engsize:14, spsize:0, thum1:true, thum2:true},
							{id:3, title:'智能存餐柜', desc:'', videourl:'103.mp4', zhsize:14, engsize:14, spsize:0, thum1:true, thum2:true},
							{id:4, title:'智能存餐柜', desc:'', videourl:'103.mp4', zhsize:11, engsize:0, spsize:0, thum1:true, thum2:true},
                {id:5, title:'智能存餐柜', desc:'', videourl:'103.mp4', zhsize:22, engsize:22, spsize:0, thum1:true, thum2:true},
                {id:6, title:'智能存餐柜', desc:'', videourl:'103.mp4', zhsize:12, engsize:12, spsize:14, thum1:true, thum2:true},
						]},
						{id:4, title:'智能洗衣柜', desc:'', size:3, children:[
							{id:1, title:'智能洗衣柜', desc:'', videourl:'104.mp4', zhsize:12, engsize:11, spsize:11, thum1:true, thum2:true},
							{id:2, title:'智能洗衣柜', desc:'', videourl:'104.mp4', zhsize:23, engsize:17, spsize:12, thum1:true, thum2:true},
                {id:3, title:'智能洗衣柜', desc:'', videourl:'104.mp4', zhsize:23, engsize:7, spsize:16, thum1:true, thum2:true},
                {id:4, title:'头盔干洗柜', desc:'', videourl:'109.mp4', zhsize:15, engsize:15, spsize:0, thum1:true, thum2:true},
						]},
						{id:5, title:'称重物料柜', desc:'', size:3, children:[
							{id:1, title:'称重物料柜', desc:'', videourl:'105.mp4', zhsize:15, engsize:14, spsize:13, thum1:true, thum2:true},
							{id:2, title:'称重物料柜', desc:'', videourl:'105.mp4', zhsize:9, engsize:9, spsize:11, thum1:true, thum2:true},
                {id:3, title:'称重物料柜', desc:'', videourl:'105.mp4', zhsize:12, engsize:12, spsize:13, thum1:true, thum2:true},
                {id:4, title:'称重物料柜', desc:'', videourl:'110.mp4', zhsize:13, engsize:13, spsize:0, thum1:true, thum2:true},
						]},
						{id:6, title:'智能洗鞋柜', desc:'', size:1, children:[
							{id:1, title:'智能洗鞋柜', desc:'', videourl:'', zhsize:10, engsize:8, spsize:10, thum1:true, thum2:true},
						]},
						{id:7, title:'运动器材柜', desc:'', size:1, children:[
							{id:1, title:'运动器材柜', desc:'', videourl:'107.mp4', zhsize:13, engsize:13, spsize:13, thum1:true, thum2:true},
						]},
						{id:8, title:'手机存取柜', desc:'', size:1, children:[
							{id:1, title:'手机存取柜', desc:'', videourl:'108.mp4', zhsize:14, engsize:14, spsize:17, thum1:true, thum2:true},
						]}
					]},
					{id:2, title:'RFID智能柜', desc:'', size:8, children:[
						{id:1, title:'智能工具柜', desc:'', size:1, children:[
							{id:1, title:'智能工具柜', desc:'', videourl:'', zhsize:11, engsize:9, spsize:11, thum1:true, thum2:true},
						]},
						{id:2, title:'智能手机柜', desc:'', size:1, children:[
							{id:1, title:'智能手机柜', desc:'', videourl:'202.mp4', zhsize:14, engsize:21, spsize:21, thum1:true, thum2:false},
						]},
						{id:3, title:'智能借书柜', desc:'', size:1, children:[
							{id:1, title:'智能借书柜', desc:'', videourl:'203.mp4', zhsize:14, engsize:14, spsize:15, thum1:true, thum2:true},
						]},
						{id:4, title:'智能文件柜', desc:'', size:1, children:[
							{id:1, title:'智能文件柜', desc:'', videourl:'204.mp4', zhsize:14, engsize:10, spsize:10, thum1:true, thum2:true},
						]},
						{id:5, title:'智能物料柜', desc:'', size:1, children:[
							{id:1, title:'智能物料柜', desc:'', videourl:'205.mp4', zhsize:17, engsize:10, spsize:14, thum1:true, thum2:true},
						]},
						{id:6, title:'智能物证柜', desc:'', size:1, children:[
							{id:1, title:'智能物证柜', desc:'', videourl:'', zhsize:15, engsize:14, spsize:15, thum1:true, thum2:true},
						]},
						{id:7, title:'智能钥匙柜', desc:'', size:2, children:[
							{id:1, title:'智能钥匙柜', desc:'', videourl:'207.mp4', zhsize:14, engsize:13, spsize:12, thum1:true, thum2:false},
                {id:2, title:'智能钥匙柜', desc:'', videourl:'207.mp4', zhsize:11, engsize:10, spsize:10, thum1:true, thum2:false},
                {id:3, title:'智能钥匙柜', desc:'', videourl:'208.mp4', zhsize:11, engsize:10, spsize:11, thum1:true, thum2:false},
						]},
					]},
					{id:3, title:'智能售货机', desc:'', size:9, children:[
						{id:1, title:'智能售货机', desc:'', size:2, children:[
							{id:1, title:'Y轴售货机', desc:'', videourl:'301.mp4', zhsize:11, engsize:9, spsize:9, thum1:true, thum2:true},
                {id:2, title:'Y轴售货机', desc:'', videourl:'301.mp4', zhsize:9, engsize:9, spsize:0, thum1:true, thum2:true},
                {id:3, title:'粉色Y轴售货机', desc:'', videourl:'3011.mp4', zhsize:15, engsize:15, spsize:0, thum1:true, thum2:true},
                {id:4, title:'XY轴售货机', desc:'', videourl:'3012.mp4', zhsize:9, engsize:9, spsize:0, thum1:true, thum2:true},
                {id:5, title:'XY轴售货机', desc:'', videourl:'3012.mp4', zhsize:22, engsize:21, spsize:9, thum1:true, thum2:true},
						]},
						{id:2, title:'格子售货机', desc:'', size:3, children:[
							{id:1, title:'格子售货机', desc:'', videourl:'302.mp4', zhsize:12, engsize:13, spsize:0, thum1:true, thum2:true},
							{id:2, title:'格子售货机', desc:'', videourl:'302.mp4', zhsize:11, engsize:0, spsize:0, thum1:true, thum2:true},
                {id:3, title:'格子售货机', desc:'', videourl:'302.mp4', zhsize:16, engsize:7, spsize:0, thum1:false, thum2:false},
                {id:4, title:'格子售货机', desc:'', videourl:'3021.mp4', zhsize:17, engsize:18, spsize:0, thum1:false, thum2:false},
						]},
						{id:3, title:'履带售货机', desc:'', size:1, children:[
							{id:1, title:'履带售货机', desc:'', videourl:'', zhsize:11, engsize:0, spsize:0, thum1:false, thum2:false},
						]},
						{id:4, title:'社区福利柜', desc:'', size:1, children:[
							{id:1, title:'社区福利柜', desc:'', videourl:'', zhsize:12, engsize:10, spsize:10, thum1:true, thum2:true},
						]},
						{id:5, title:'无屏可视售货机', desc:'', size:1, children:[
							{id:1, title:'无屏可视售货机', desc:'', videourl:'305.mp4', zhsize:14, engsize:7, spsize:0, thum1:false, thum2:false},
						]},
						{id:6, title:'智能药品柜', desc:'', size:1, children:[
							{id:1, title:'智能药品柜', desc:'', videourl:'', zhsize:6, engsize:6, spsize:0, thum1:true, thum2:true},
						]},
						{id:7, title:'智能口罩售卖机', desc:'', size:1, children:[
							{id:1, title:'智能口罩售卖机', desc:'', videourl:'307.mp4', zhsize:8, engsize:0, spsize:0, thum1:true, thum2:true},
						]},
              {id:8, title:'智能售货机', desc:'', size:1, children:[
                  {id:1, title:'双货道售货机', desc:'', videourl:'309.mp4', zhsize:15, engsize:15, spsize:0, thum1:true, thum2:true},
                  {id:2, title:'迷你售货机', desc:'', videourl:'310.mp4', zhsize:10, engsize:12, spsize:0, thum1:true, thum2:true},
                  {id:3, title:'卡片机', desc:'', videourl:'', zhsize:8, engsize:8, spsize:0, thum1:true, thum2:true},
                  {id:4, title:'32吋一体机售货机', desc:'', videourl:'', zhsize:12, engsize:4, spsize:0, thum1:true, thum2:true},
                ]},
					]},
					{id:4, title:'智能一体机', desc:'', size:12, children:[
						{ id:1, title:'智能一体机', desc:'', size:12, children:[
							{id:1, title:'7吋一体机', desc:'', videourl:'400.mp4', zhsize:16, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:2, title:'10.1吋一体机', desc:'', videourl:'400.mp4', zhsize:12, engsize:12, spsize:0, thum1:false, thum2:false},
							{id:3, title:'12.1吋一体机', desc:'', videourl:'400.mp4', zhsize:13, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:4, title:'15吋一体机', desc:'', videourl:'400.mp4', zhsize:19, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:5, title:'15.6吋一体机', desc:'', videourl:'400.mp4', zhsize:17, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:6, title:'17吋一体机', desc:'', videourl:'400.mp4', zhsize:17, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:7, title:'18.5吋一体机', desc:'', videourl:'400.mp4', zhsize:13, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:8, title:'19吋一体机', desc:'', videourl:'400.mp4', zhsize:12, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:9, title:'21.5吋一体机', desc:'', videourl:'400.mp4', zhsize:14, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:10, title:'23.6吋一体机', desc:'', videourl:'400.mp4', zhsize:15, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:11, title:'27吋一体机', desc:'', videourl:'400.mp4', zhsize:13, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:12, title:'32吋一体机', desc:'', videourl:'400.mp4', zhsize:15, engsize:0, spsize:0, thum1:false, thum2:false},
						]}
					]},
					{id:5, title:'IoT控制板', desc:'', size:21, children:[
						{id:1, title:'IoT控制板', desc:'', size:21, children:[
							{id:1, title:'2号锁控板带灯控', desc:'', videourl:'5011.mp4', zhsize:14, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:2, title:'8路锁控板', desc:'', videourl:'5013.mp4', zhsize:12, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:3, title:'8路电机板', desc:'', videourl:'5012.mp4', zhsize:13, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:4, title:'12路锁控板', desc:'', videourl:'5014.mp4', zhsize:13, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:5, title:'12路锁控板带灯', desc:'', videourl:'5014.mp4', zhsize:14, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:6, title:'12路锁控板带正反限位', desc:'', videourl:'5014.mp4', zhsize:15, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:7, title:'15路锁控板', desc:'', videourl:'5017.mp4', zhsize:12, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:8, title:'18路锁控板', desc:'', videourl:'5018.mp4', zhsize:13, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:9, title:'25路锁控板带灯', desc:'', videourl:'5019.mp4', zhsize:14, engsize:14, spsize:11, thum1:false, thum2:false},
							{id:10, title:'25路锁控板', desc:'', videourl:'5020.mp4', zhsize:12, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:11, title:'27路锁控板', desc:'', videourl:'5021.mp4', zhsize:15, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:12, title:'50路锁控板', desc:'', videourl:'5022.mp4', zhsize:7, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:13, title:'多功能锁控板', desc:'', videourl:'5023.mp4', zhsize:12, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:14, title:'继电器控制板', desc:'', videourl:'5024.mp4', zhsize:10, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:15, title:'8路温控板', desc:'', videourl:'5012.mp4', zhsize:10, engsize:0, spsize:0, thum1:false, thum2:false},
              {id:16, title:'25路称重板', title1:'25路称重板', desc:'', videourl:'5026.mp4', zhsize:12, engsize:12, spsize:14, thum1:false, thum2:false},
              {id:17, title:'36路锁控板', title1:'36路锁控板', desc:'', videourl:'5027.mp4', zhsize:15, engsize:15, spsize:13, thum1:false, thum2:false},
              {id:18, title:'XYZ控制板', title1:'XYZ控制板', desc:'', videourl:'5028.mp4', zhsize:13, engsize:12, spsize:11, thum1:false, thum2:false},
              {id:19, title:'充电板', title1:'充电板', desc:'', videourl:'5029.mp4', zhsize:11, engsize:11, spsize:11, thum1:false, thum2:false},
              {id:20, title:'电控板', title1:'电控板', desc:'', videourl:'5030.mp4', zhsize:15, engsize:15, spsize:14, thum1:false, thum2:false},
              {id:21, title:'屏控板', title1:'屏控板', desc:'', videourl:'5031.mp4', zhsize:13, engsize:13, spsize:0, thum1:false, thum2:false},
						]}
					]},
					{id:6, title:'数据透传模块', desc:'', size:4, children:[
						{id:1, title:'数据透传模块', desc:'', size:4, children:[
							{id:1, title:'4G DTU-5.3', desc:'', videourl:'6011.mp4', zhsize:13, engsize:13, spsize:0, thum1:false, thum2:false},
							{id:2, title:'4G DTU-6.0', desc:'', videourl:'6012.mp4', zhsize:11, engsize:13, spsize:0, thum1:false, thum2:false},
							{id:3, title:'RJ45 DTU', desc:'', videourl:'6013.mp4', zhsize:8, engsize:7, spsize:0, thum1:false, thum2:false},
							{id:4, title:'WiFi DTU', desc:'', videourl:'6014.mp4', zhsize:8, engsize:8, spsize:0, thum1:false, thum2:false},
						]}
					]},
					{id:7, title:'人脸识别终端', desc:'', size:3, children:[
						{id:1, title:'人脸识别终端', desc:'', size:3, children:[
							{id:1, title:'7吋人脸识别终端-平板', desc:'', videourl:'7011.mp4', zhsize:22, engsize:22, spsize:0, thum1:true, thum2:true},
							{id:2, title:'7吋人脸识别终端-圆柱', desc:'', videourl:'7011.mp4', zhsize:19, engsize:19, spsize:0, thum1:false, thum2:false},
							{id:3, title:'8吋人脸识别终端', desc:'', videourl:'7011.mp4', zhsize:16, engsize:16, spsize:0, thum1:false, thum2:false},
						]}
					]},
				],
				prolist2: [
					{id:1, title:'Smart Access Cabinet', desc:'', size:22, children:[
						{id:1, title:'Smart express cabinet', desc:'', size:4, children:[
							{id:1, title:'Smart express cabinet', desc:'', videourl:'', zhsize:14, engsize:22, spsize:0, thum1:true, thum2:true},
							{id:2, title:'Smart express cabinet', desc:'', videourl:'', zhsize:13, engsize:12, spsize:0, thum1:true, thum2:true},
							{id:3, title:'Smart express cabinet', desc:'', videourl:'', zhsize:12, engsize:16, spsize:0, thum1:true, thum2:true},
							{id:4, title:'Smart express cabinet', desc:'', videourl:'', zhsize:20, engsize:0, spsize:0, thum1:true, thum2:true},
						]},
						{id:2, title:'Smart locker cabinet', desc:'', size:4, children:[
							{id:1, title:'Smart locker cabinet', desc:'', videourl:'', zhsize:13, engsize:13, spsize:0, thum1:true, thum2:true},
							{id:2, title:'Smart locker cabinet', desc:'', videourl:'', zhsize:11, engsize:9, spsize:0, thum1:true, thum2:true},
							{id:3, title:'Smart locker cabinet', desc:'', videourl:'', zhsize:8, engsize:8, spsize:0, thum1:true, thum2:true},
							{id:4, title:'Smart locker cabinet', desc:'', videourl:'', zhsize:21, engsize:21, spsize:0, thum1:true, thum2:false},
						]},
						{id:3, title:'Smart save meal cabinet', desc:'', size:5, children:[
							{id:1, title:'Smart save meal cabinet', desc:'', videourl:'1031.mp4', zhsize:17, engsize:17, spsize:0, thum1:true, thum2:true},
							{id:2, title:'Smart save meal cabinet', desc:'', videourl:'1032.mp4', zhsize:14, engsize:14, spsize:0, thum1:true, thum2:true},
							{id:3, title:'Smart save meal cabinet', desc:'', videourl:'103.mp4', zhsize:14, engsize:14, spsize:0, thum1:true, thum2:true},
							{id:4, title:'Smart save meal cabinet', desc:'', videourl:'103.mp4', zhsize:16, engsize:16, spsize:15, thum1:true, thum2:true},
							{id:5, title:'Smart save meal cabinet', desc:'', videourl:'103.mp4', zhsize:22, engsize:22, spsize:17, thum1:true, thum2:true},
                {id:6, title:'Smart save meal cabinet', desc:'', videourl:'103.mp4', zhsize:12, engsize:12, spsize:14, thum1:true, thum2:true},
						]},
						{id:4, title:'Smart washing cabinet', desc:'', size:3, children:[
							{id:1, title:'Smart washing cabinet', desc:'', videourl:'', zhsize:12, engsize:11, spsize:11, thum1:true, thum2:true},
							{id:2, title:'Smart washing cabinet', desc:'', videourl:'', zhsize:23, engsize:17, spsize:12, thum1:true, thum2:true},
							{id:3, title:'Smart washing cabinet', desc:'', videourl:'', zhsize:23, engsize:7, spsize:16, thum1:true, thum2:true},
                {id:4, title:'Helmet dry cleaning cabinet', desc:'', videourl:'109.mp4', zhsize:15, engsize:15, spsize:0, title1:'头盔干洗柜', thum1:true, thum2:true},
						]},
						{id:5, title:'Weighing material cabinet', desc:'', size:3, children:[
							{id:1, title:'Weighing material cabinet', desc:'', videourl:'105.mp4', zhsize:15, engsize:14, spsize:13, thum1:true, thum2:true},
							{id:2, title:'Weighing material cabinet', desc:'', videourl:'105.mp4', zhsize:9, engsize:9, spsize:11, thum1:true, thum2:true},
                {id:3, title:'Weighing material cabinet', desc:'', videourl:'105.mp4', zhsize:12, engsize:12, spsize:13, thum1:true, thum2:true},
                {id:4, title:'Weighing material cabinet', desc:'', videourl:'110.mp4', zhsize:13, engsize:13, spsize:0, thum1:true, thum2:true},
						]},
						{id:6, title:'Smart shoe washing cabinet', desc:'', size:1, children:[
							{id:1, title:'Smart shoe washing cabinet', desc:'', videourl:'', zhsize:10, engsize:8, spsize:10, thum1:true, thum2:true},
						]},
						{id:7, title:'Sports equipment cabinet', desc:'', size:1, children:[
							{id:1, title:'Sports equipment cabinet', desc:'', videourl:'', zhsize:13, engsize:13, spsize:13, thum1:true, thum2:true},
						]},
						{id:8, title:'Mobile phone access cabinet', desc:'', size:1, children:[
							{id:1, title:'Mobile phone access cabinet', desc:'', videourl:'108.mp4', zhsize:14, engsize:14, spsize:17, thum1:true, thum2:true},
						]}
					]},
					{id:2, title:'RFID Smart Cabinet', desc:'', size:8, children:[
						{id:1, title:'Smart tool cabinet', desc:'', size:1, children:[
							{id:1, title:'Smart tool cabinet', desc:'', videourl:'', zhsize:11, engsize:9, spsize:11, thum1:true, thum2:true},
						]},
						{id:2, title:'Smart phone cabinet', desc:'', size:1, children:[
							{id:1, title:'Smart phone cabinet', desc:'', videourl:'202.mp4', zhsize:14, engsize:21, spsize:17, thum1:true, thum2:false},
						]},
						{id:3, title:'Smart borrow bookcase', desc:'', size:1, children:[
							{id:1, title:'Smart borrow bookcase', desc:'', videourl:'203.mp4', zhsize:14, engsize:14, spsize:15, thum1:true, thum2:true},
						]},
						{id:4, title:'Smart file cabinet', desc:'', size:1, children:[
							{id:1, title:'Smart file cabinet', desc:'', videourl:'', zhsize:14, engsize:10, spsize:10, thum1:true, thum2:true},
						]},
						{id:5, title:'Smart material cabinet', desc:'', size:1, children:[
							{id:1, title:'Smart material cabinet', desc:'', videourl:'205.mp4', zhsize:17, engsize:10, spsize:14, thum1:true, thum2:true},
						]},
						{id:6, title:'Smart evidence cabinet', desc:'', size:1, children:[
							{id:1, title:'Smart evidence cabinet', desc:'', videourl:'', zhsize:15, engsize:14, spsize:15, thum1:true, thum2:true},
						]},
						{id:7, title:'Smart key cabinet', desc:'', size:2, children:[
							{id:1, title:'Smart key cabinet', desc:'', videourl:'207.mp4', zhsize:14, engsize:13, spsize:12, thum1:true, thum2:false},
                {id:2, title:'Smart key cabinet', desc:'', videourl:'207.mp4', zhsize:11, engsize:10, spsize:10, thum1:true, thum2:false},
                {id:3, title:'Smart key cabinet', desc:'', videourl:'208.mp4', zhsize:11, engsize:10, spsize:11, thum1:true, thum2:false},
						]},
					]},
					{id:3, title:'Smart vending machine', desc:'', size:9, children:[
						{id:1, title:'Y-axis vending machine', desc:'', size:1, children:[
							{id:1, title:'Y-axis vending machine', desc:'', videourl:'', zhsize:11, engsize:9, spsize:9, thum1:true, thum2:true},
							{id:2, title:'Y-axis vending machine', desc:'', videourl:'', zhsize:9, engsize:9, spsize:11, thum1:true, thum2:true},
                {id:3, title:'Pink Y-axis vending machine', desc:'粉色y轴售货机', videourl:'3011.mp4', zhsize:15, engsize:15, spsize:0, thum1:true, thum2:true},
                {id:4, title:'XY-axis vending machine', title1:'XY轴售货机', desc:'', videourl:'3012.mp4', zhsize:9, engsize:9, spsize:0, thum1:true, thum2:true},
                {id:5, title:'XY-axis vending machine', title1:'XY轴售货机', desc:'', videourl:'3012.mp4', zhsize:22, engsize:21, spsize:9, thum1:true, thum2:true},
						]},
						{id:2, title:'Grid vending machine', desc:'', size:3, children:[
							{id:1, title:'Grid vending machine', desc:'', videourl:'302.mp4', zhsize:12, engsize:13, spsize:0, thum1:true, thum2:true},
							{id:2, title:'Grid vending machine', desc:'', videourl:'302.mp4', zhsize:11, engsize:0, spsize:0, thum1:true, thum2:true},
                {id:3, title:'Grid vending machine', desc:'', videourl:'302.mp4', zhsize:16, engsize:7, spsize:0, thum1:false, thum2:false},
                {id:4, title:'Grid vending machine', desc:'', videourl:'3021.mp4', zhsize:17, engsize:18, spsize:0, thum1:false, thum2:false},
						]},
						{id:3, title:'Crawler vending machine', desc:'', size:1, children:[
							{id:1, title:'Crawler vending machine', desc:'', videourl:'', zhsize:11, engsize:11, spsize:10, thum1:false, thum2:false},
						]},
						{id:4, title:'Community welfare counter', desc:'', size:1, children:[
							{id:1, title:'Community welfare counter', desc:'', videourl:'', zhsize:12, engsize:10, spsize:10, thum1:true, thum2:true},
						]},
						{id:5, title:'No screen visual vending machine', desc:'', size:1, children:[
							{id:1, title:'No screen visual vending machine', desc:'', videourl:'', zhsize:14, engsize:7, spsize:0, thum1:false, thum2:false},
						]},
						{id:6, title:'Smart medicine cabinet', desc:'', size:1, children:[
							{id:1, title:'Smart medicine cabinet', desc:'', videourl:'', zhsize:6, engsize:6, spsize:7, thum1:true, thum2:true},
						]},
						{id:7, title:'Smart mask vending machine', desc:'', size:1, children:[
							{id:1, title:'Smart mask vending machine', desc:'', videourl:'307.mp4', zhsize:8, engsize:7, spsize:7, thum1:true, thum2:true},
						]},
              {id:8, title:'Smart vending machine', desc:'', size:1, children:[
                  {id:1, title:'Double aisle vending machine', desc:'', videourl:'309.mp4', zhsize:15, engsize:15, spsize:0, thum1:true, thum2:true},
                  {id:2, title:'mini vending machine', desc:'', videourl:'310.mp4', zhsize:10, engsize:12, spsize:0, thum1:true, thum2:true},
                  {id:3, title:'Card vending machine', desc:'', videourl:'', zhsize:8, engsize:8, spsize:0, thum1:true, thum2:true},
                  {id:4, title:'32-inch all-in-one vending machine', desc:'', videourl:'', zhsize:12, engsize:4, spsize:0, thum1:true, thum2:true},
                ]},
					]},
					{id:4, title:'Smart all-in-one machine', desc:'', size:12, children:[
						{ id:1, title:'Smart all-in-one machine', desc:'', videourl:'400.mp4', size:12, children:[
							{id:1, title:'7 "All-in-one', desc:'', videourl:'400.mp4', zhsize:16, engsize:12, spsize:0, thum1:false, thum2:false},
							{id:2, title:'10.1 "All-in-one', desc:'', videourl:'400.mp4', zhsize:12, engsize:12, spsize:0, thum1:false, thum2:false},
							{id:3, title:'12.1 "All-in-one', desc:'', videourl:'400.mp4', zhsize:13, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:4, title:'15 "All-in-one', desc:'', videourl:'400.mp4', zhsize:19, engsize:12, spsize:17, thum1:false, thum2:false},
							{id:5, title:'15.6 "All-in-one', desc:'', videourl:'400.mp4', zhsize:17, engsize:12, spsize:0, thum1:false, thum2:false},
							{id:6, title:'17 "All-in-one', desc:'', videourl:'400.mp4', zhsize:17, engsize:18, spsize:0, thum1:false, thum2:false},
							{id:7, title:'18.5 "All-in-one', desc:'', videourl:'400.mp4', zhsize:13, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:8, title:'19 "All-in-one', desc:'', videourl:'400.mp4', zhsize:12, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:9, title:'21.5 "All-in-one', desc:'', videourl:'400.mp4', zhsize:14, engsize:11, spsize:0, thum1:false, thum2:false},
							{id:10, title:'23.6 "All-in-one', desc:'', videourl:'400.mp4', zhsize:15, engsize:17, spsize:0, thum1:false, thum2:false},
							{id:11, title:'27 "All-in-one', desc:'', videourl:'400.mp4', zhsize:13, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:12, title:'32 "All-in-one', desc:'', videourl:'400.mp4', zhsize:15, engsize:17, spsize:0, thum1:false, thum2:false},
						]}
					]},
					{id:5, title:'IoT Control Panel', desc:'', size:15, children:[
						{id:1, title:'IoT Control Panel', desc:'', size:15, children:[
							{id:1, title:'Lock board No. 2 with light control', desc:'', videourl:'5011.mp4', zhsize:14, engsize:14, spsize:0, thum1:false, thum2:false},
							{id:2, title:'8 way lock control board', desc:'', videourl:'5013.mp4', zhsize:12, engsize:10, spsize:0, thum1:false, thum2:false},
							{id:3, title:'8 Road motor plate', desc:'', videourl:'5012.mp4', zhsize:13, engsize:12, spsize:0, thum1:false, thum2:false},
							{id:4, title:'12 way lock control board', desc:'', videourl:'5014.mp4', zhsize:13, engsize:13, spsize:0, thum1:false, thum2:false},
							{id:5, title:'12 way lock control board with lamp', desc:'', videourl:'5014.mp4', zhsize:14, engsize:13, spsize:0, thum1:false, thum2:false},
							{id:6, title:'12 way lock control board With positive and negative limit', desc:'', videourl:'5014.mp4', zhsize:15, engsize:12, spsize:0, thum1:false, thum2:false},
							{id:7, title:'15 way lock control board', desc:'', videourl:'5017.mp4', zhsize:12, engsize:13, spsize:0, thum1:false, thum2:false},
							{id:8, title:'18 way lock control board', desc:'', videourl:'5018.mp4', zhsize:13, engsize:13, spsize:0, thum1:false, thum2:false},
							{id:9, title:'25 way lock control board with lamp', desc:'', videourl:'5018.mp4', zhsize:14, engsize:14, spsize:11, thum1:false, thum2:false},
							{id:10, title:'25 way lock control board', desc:'', videourl:'5020.mp4', zhsize:12, engsize:12, spsize:0, thum1:false, thum2:false},
							{id:11, title:'27 way lock control board', desc:'', videourl:'5021.mp4', zhsize:15, engsize:13, spsize:0, thum1:false, thum2:false},
							{id:12, title:'50 way lock control board', desc:'', videourl:'5022.mp4', zhsize:7, engsize:7, spsize:0, thum1:false, thum2:false},
							{id:13, title:'Multi-function lock control board', desc:'', videourl:'5023.mp4', zhsize:12, engsize:11, spsize:0, thum1:false, thum2:false},
							{id:14, title:'Relay control panel', desc:'', videourl:'5024.mp4', zhsize:10, engsize:10, spsize:0, thum1:false, thum2:false},
							{id:15, title:'8 way temperature control board', desc:'', videourl:'5012.mp4', zhsize:10, engsize:10, spsize:0, thum1:false, thum2:false},
              {id:16, title:'25-way weighing board', title1:'25路称重板', desc:'', videourl:'5026.mp4', zhsize:12, engsize:12, spsize:14, thum1:false, thum2:false},
              {id:17, title:'36-way lock control board', title1:'36路锁控板', desc:'', videourl:'5027.mp4', zhsize:15, engsize:15, spsize:13, thum1:false, thum2:false},
              {id:18, title:'XYZ control panel', title1:'XYZ控制板', desc:'', videourl:'5028.mp4', zhsize:13, engsize:12, spsize:11, thum1:false, thum2:false},
              {id:19, title:'Charging board', title1:'充电板', desc:'', videourl:'5029.mp4', zhsize:11, engsize:11, spsize:11, thum1:false, thum2:false},
              {id:20, title:'Electrical control panel', title1:'电控板', desc:'', videourl:'5030.mp4', zhsize:15, engsize:15, spsize:14, thum1:false, thum2:false},
              {id:21, title:'Screen control panel', title1:'屏控板', desc:'', videourl:'5031.mp4', zhsize:13, engsize:13, spsize:0, thum1:false, thum2:false},
						]}
					]},
					{id:6, title:'Data passthrough module', desc:'', size:4, children:[
						{id:1, title:'Data passthrough module', desc:'', size:4, children:[
							{id:1, title:'4G DTU-5.3', desc:'', videourl:'6011.mp4', zhsize:13, engsize:13, spsize:0, thum1:false, thum2:false},
							{id:2, title:'4G DTU-6.0', desc:'', videourl:'6012.mp4', zhsize:13, engsize:13, spsize:0, thum1:false, thum2:false},
							{id:3, title:'RJ45 DTU', desc:'', videourl:'6013.mp4', zhsize:8, engsize:7, spsize:0, thum1:false, thum2:false},
							{id:4, title:'WiFi DTU', desc:'', videourl:'6014.mp4', zhsize:8, engsize:8, spsize:0, thum1:false, thum2:false},
						]}
					]},
					{id:7, title:'Face recognition terminal', desc:'', size:3, children:[
						{id:1, title:'Face recognition terminal', desc:'', size:3, children:[
							{id:1, title:'7 "face recognition terminal - tablet', desc:'', videourl:'7011', zhsize:22, engsize:22, spsize:0, thum1:true, thum2:true},
							{id:2, title:'7 "face recognition terminal - cylindrical', desc:'', videourl:'7011', zhsize:19, engsize:19, spsize:0, thum1:false, thum2:false},
							{id:3, title:'8 "face recognition terminal', desc:'', videourl:'7011', zhsize:16, engsize:16, spsize:0, thum1:false, thum2:false},
						]}
					]},
				],
				prolist3: [
					{id:1, title:'Gabinete de acceso inteligente', desc:'', size:22, children:[
						{id:1, title:'Gabinete expreso inteligente', desc:'智能快递柜', size:4, children:[
							{id:1, title:'Gabinete expreso inteligente', desc:'', videourl:'', zhsize:14, engsize:22, spsize:16, thum1:true, thum2:true},
							{id:2, title:'Gabinete expreso inteligente', desc:'', videourl:'', zhsize:13, engsize:12, spsize:12, thum1:true, thum2:true},
							{id:3, title:'Gabinete expreso inteligente', desc:'', videourl:'', zhsize:12, engsize:16, spsize:16, thum1:true, thum2:true},
							//{id:4, title:'Gabinete expreso inteligente', desc:'', videourl:'', zhsize:20, engsize:0, spsize:0, thum1:true, thum2:true},
						]},
						{id:2, title:'Gabinete de almacenamiento inteligente de paquetes', desc:'智能存包柜', videourl:'', size:4, children:[
							{id:1, title:'Gabinete de almacenamiento inteligente de paquetes', desc:'', videourl:'', zhsize:13, engsize:13, spsize:12, thum1:true, thum2:true},
							{id:2, title:'Gabinete de almacenamiento inteligente de paquetes', desc:'', videourl:'', zhsize:11, engsize:9, spsize:10, thum1:true, thum2:true},
							{id:3, title:'Gabinete de almacenamiento inteligente de paquetes', desc:'', videourl:'', zhsize:8, engsize:8, spsize:9, thum1:true, thum2:true},
							{id:4, title:'Gabinete de almacenamiento inteligente de paquetes', desc:'', videourl:'', zhsize:21, engsize:21, spsize:15, thum1:true, thum2:false},
						]},
						{id:3, title:'Gabinete de almacenamiento inteligente', desc:'智能存餐柜', size:5, children:[
							{id:1, title:'Gabinete de almacenamiento inteligente', desc:'', videourl:'1031.mp4', zhsize:17, engsize:17, spsize:17, thum1:true, thum2:true},
							{id:2, title:'Gabinete de almacenamiento inteligente', desc:'', videourl:'1032.mp4', zhsize:14, engsize:14, spsize:15, thum1:true, thum2:true},
							{id:3, title:'Gabinete de almacenamiento inteligente', desc:'', videourl:'103.mp4', zhsize:14, engsize:14, spsize:15, thum1:true, thum2:true},
							{id:4, title:'Gabinete de almacenamiento inteligente', desc:'', videourl:'103.mp4', zhsize:16, engsize:16, spsize:15, thum1:true, thum2:true},
							{id:5, title:'Gabinete de almacenamiento inteligente', desc:'', videourl:'103.mp4', zhsize:22, engsize:22, spsize:17, thum1:true, thum2:true},
                {id:6, title:'Gabinete de almacenamiento inteligente', desc:'', videourl:'103.mp4', zhsize:12, engsize:12, spsize:14, thum1:true, thum2:true},
						]},
						{id:4, title:'Armario de lavado inteligente', desc:'智能洗衣柜', size:3, children:[
							{id:1, title:'Armario de lavado inteligente', desc:'', videourl:'', zhsize:12, engsize:11, spsize:11, thum1:true, thum2:true},
							{id:2, title:'Armario de lavado inteligente', desc:'', videourl:'', zhsize:23, engsize:17, spsize:12, thum1:true, thum2:true},
							{id:3, title:'Armario de lavado inteligente', desc:'', videourl:'', zhsize:23, engsize:7, spsize:16, thum1:true, thum2:true},
                {id:4, title:'Armario de limpieza en seco para cascos.', desc:'', videourl:'109.mp4', zhsize:15, engsize:15, spsize:0, title1:'头盔干洗柜', thum1:true, thum2:true},
						]},
						{id:5, title:'Gabinete de material de pesaje', desc:'称重物料柜', size:3, children:[
							{id:1, title:'Gabinete de material de pesaje', desc:'', videourl:'105.mp4', zhsize:15, engsize:14, spsize:13, thum1:true, thum2:true},
							{id:2, title:'Gabinete de material de pesaje', desc:'', videourl:'105.mp4', zhsize:9, engsize:9, spsize:11, thum1:true, thum2:true},
                {id:3, title:'Gabinete de material de pesaje', desc:'', videourl:'105.mp4', zhsize:12, engsize:12, spsize:13, thum1:true, thum2:true},
                {id:4, title:'Gabinete de material de pesaje', desc:'', videourl:'110.mp4', zhsize:13, engsize:13, spsize:0, thum1:true, thum2:true},
						]},
						{id:6, title:'Gabinete de lavado de zapatos inteligente', desc:'智能洗鞋柜', size:1, children:[
							{id:1, title:'Gabinete de lavado de zapatos inteligente', desc:'', videourl:'', zhsize:8, engsize:10, spsize:10, thum1:true, thum2:true},
						]},
						{id:7, title:'Gabinete de equipamiento deportivo', desc:'运动器材柜', size:1, children:[
							{id:1, title:'Gabinete de equipamiento deportivo', desc:'', videourl:'', zhsize:13, engsize:13, spsize:13, thum1:true, thum2:true},
						]},
						{id:8, title:'Gabinete de acceso móvil', desc:'手机存取柜', size:1, children:[
							{id:1, title:'Gabinete de acceso móvil', desc:'', videourl:'108.mp4', zhsize:14, engsize:14, spsize:17, thum1:true, thum2:true},
						]}
					]},
					{id:2, title:'Gabinete inteligente RFID', desc:'', size:8, children:[
						{id:1, title:'Gabinete de herramientas inteligente', desc:'智能工具柜', size:1, children:[
							{id:1, title:'Gabinete de herramientas inteligente', desc:'', videourl:'', zhsize:11, engsize:9, spsize:11, thum1:true, thum2:true},
						]},
						{id:2, title:'Gabinete de mano inteligente', desc:'智能手机柜', size:1, children:[
							{id:1, title:'Gabinete de mano inteligente', desc:'', videourl:'202.mp4', zhsize:14, engsize:21, spsize:17, thum1:true, thum2:false},
						]},
						{id:3, title:'Biblioteca de préstamo inteligente', desc:'智能借书柜', size:1, children:[
							{id:1, title:'Biblioteca de préstamo inteligente', desc:'', videourl:'203.mp4', zhsize:14, engsize:14, spsize:15, thum1:true, thum2:true},
						]},
						{id:4, title:'Archivador inteligente', desc:'智能文件柜', size:1, children:[
							{id:1, title:'Archivador inteligente', desc:'', videourl:'', zhsize:14, engsize:10, spsize:10, thum1:true, thum2:true},
						]},
						{id:5, title:'Gabinete de materiales inteligente', desc:'智能物料柜', size:1, children:[
							{id:1, title:'Gabinete de materiales inteligente', desc:'', videourl:'205.mp4', zhsize:17, engsize:10, spsize:14, thum1:true, thum2:true},
						]},
						{id:6, title:'Gabinete de evidencia física inteligente', desc:'智能物证柜', size:1, children:[
							{id:1, title:'Gabinete de evidencia física inteligente', desc:'', videourl:'', zhsize:15, engsize:14, spsize:15, thum1:true, thum2:true},
						]},
						{id:7, title:'Gabinete con llave inteligente', desc:'智能钥匙柜', size:2, children:[
							{id:1, title:'Gabinete con llave inteligente', desc:'', videourl:'207.mp4', zhsize:14, engsize:13, spsize:12, thum1:true, thum2:false},
                {id:2, title:'Gabinete con llave inteligente', desc:'', videourl:'207.mp4', zhsize:11, engsize:10, spsize:10, thum1:true, thum2:false},
                {id:3, title:'Gabinete con llave inteligente', desc:'', videourl:'208.mp4', zhsize:11, engsize:10, spsize:11, thum1:true, thum2:false},
						]},
					]},
					{id:3, title:'Máquina vending inteligente', desc:'', size:9, children:[
						{id:1, title:'Máquina expendedora del eje y', desc:'', size:1, children:[
							{id:1, title:'Máquina expendedora del eje y', desc:'y轴售货机', videourl:'', zhsize:11, engsize:9, spsize:9, thum1:true, thum2:true},
							{id:2, title:'áquina expendedora del eje xy', desc:'y轴售货机', videourl:'301.mp4', zhsize:9, engsize:9, spsize:11, thum1:true, thum2:true},
                {id:3, title:'Máquina expendedora rosa del eje y', desc:'粉色y轴售货机', videourl:'3011.mp4', zhsize:15, engsize:15, spsize:0, thum1:true, thum2:true},
                {id:4, title:'Máquina expendedora del eje XY', title1:'XY轴售货机', desc:'', videourl:'3012.mp4', zhsize:9, engsize:9, spsize:0, thum1:true, thum2:true},
                {id:5, title:'Máquina expendedora del eje XY', title1:'XY轴售货机', desc:'', videourl:'3012.mp4', zhsize:22, engsize:21, spsize:9, thum1:true, thum2:true},
						]},
						{id:2, title:'Máquina expendedora', desc:'格子售货机', size:3, children:[
							{id:1, title:'Máquina expendedora', desc:'', videourl:'302.mp4', zhsize:12, engsize:13, spsize:8, thum1:true, thum2:true},
							{id:2, title:'Máquina expendedora', desc:'', videourl:'302.mp4', zhsize:11, engsize:12, spsize:11, thum1:true, thum2:true},
                {id:3, title:'Máquina expendedora', desc:'', videourl:'302.mp4', zhsize:16, engsize:7, spsize:11, thum1:false, thum2:false},
                {id:4, title:'Máquina expendedora', desc:'', videourl:'3021.mp4', zhsize:17, engsize:18, spsize:11, thum1:false, thum2:false},
						]},
						{id:3, title:'Máquina expendedora de orugas', desc:'履带售货机', size:1, children:[
							{id:1, title:'Máquina expendedora de orugas', desc:'', videourl:'', zhsize:11, engsize:11, spsize:10, thum1:false, thum2:false},
						]},
						{id:4, title:'Gabinete de beneficios comunitarios', desc:'社区福利柜', size:1, children:[
							{id:1, title:'Gabinete de beneficios comunitarios', desc:'', videourl:'', zhsize:12, engsize:10, spsize:10, thum1:true, thum2:true},
						]},
						{id:5, title:'Vending visual sin pantalla', desc:'无屏可视售货机', size:1, children:[
							{id:1, title:'Vending visual sin pantalla', desc:'', videourl:'', zhsize:14, engsize:7, spsize:9, thum1:false, thum2:false},
						]},
						{id:6, title:'Gabinete farmacéutico inteligente', desc:'智能药品柜', size:1, children:[
							{id:1, title:'Gabinete farmacéutico inteligente', desc:'', videourl:'', zhsize:6, engsize:6, spsize:7, thum1:true, thum2:true},
						]},
						{id:7, title:'Máquina expendedora de mascarillas inteligente', desc:'智能口罩售卖机', size:1, children:[
							{id:1, title:'Máquina expendedora de mascarillas inteligente', desc:'', videourl:'307.mp4', zhsize:8, engsize:7, spsize:7, thum1:true, thum2:true},
						]},
              {id:8, title:'Máquina expendedora inteligente', desc:'', size:1, children:[
                  {id:1, title:'Máquina expendedora de doble pasill', desc:'', videourl:'309.mp4', zhsize:15, engsize:15, spsize:0, thum1:true, thum2:true},
                  {id:2, title:'mini máquina expendedora', desc:'', videourl:'310.mp4', zhsize:10, engsize:12, spsize:0, thum1:true, thum2:true},
                  {id:3, title:'maquina de tarjetas', desc:'', videourl:'', zhsize:8, engsize:8, spsize:0, thum1:true, thum2:true},
                  {id:4, title:'Máquina expendedora todo en uno de 32 pulgadas', desc:'', videourl:'', zhsize:12, engsize:4, spsize:0, thum1:true, thum2:true},
                ]},
					]},
					{id:4, title:'Inteligente todo en uno', desc:'', size:12, children:[
						{ id:1, title:'Inteligente todo en uno', desc:'', size:12, children:[
							{id:1, title:'7 "todo en uno', desc:'7吋一体机', videourl:'400.mp4', zhsize:16, engsize:12, spsize:18, thum1:false, thum2:false},
							{id:2, title:'10.1 "todo en uno', desc:'', videourl:'400.mp4', zhsize:12, engsize:12, spsize:13, thum1:false, thum2:false},
							{id:3, title:'12.1 "todo en uno', desc:'1', videourl:'400.mp4', zhsize:13, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:4, title:'15 "todo en uno', desc:'', videourl:'400.mp4', zhsize:19, engsize:12, spsize:17, thum1:false, thum2:false},
							{id:5, title:'15.6 "todo en uno', desc:'', videourl:'400.mp4', zhsize:17, engsize:0, spsize:16, thum1:false, thum2:false},
							{id:6, title:'17 "todo en uno', desc:'', videourl:'400.mp4', zhsize:17, engsize:18, spsize:17, thum1:false, thum2:false},
							{id:7, title:'18.5 "todo en uno', desc:'1', videourl:'400.mp4', zhsize:13, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:8, title:'19 "todo en uno', desc:'1', videourl:'400.mp4', zhsize:12, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:9, title:'21.5 "todo en uno', desc:'', videourl:'400.mp4', zhsize:14, engsize:11, spsize:17, thum1:false, thum2:false},
							{id:10, title:'23.6 "todo en uno', desc:'', videourl:'400.mp4', zhsize:15, engsize:17, spsize:17, thum1:false, thum2:false},
							{id:11, title:'27 "todo en uno', desc:'1', videourl:'400.mp4', zhsize:13, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:12, title:'32 "todo en uno', desc:'', videourl:'400.mp4', zhsize:15, engsize:17, spsize:17, thum1:false, thum2:false},
						]}
					]},
					{id:5, title:'Placa de control IoT', desc:'', size:15, children:[
						{id:1, title:'Placa de control IoT', desc:'', size:15, children:[
							{id:1, title:'No. 2 tablero de control de bloqueo con control de luz', desc:'', videourl:'5011.mp4', zhsize:14, engsize:14, spsize:9, thum1:false, thum2:false},
							{id:2, title:'Tablero de control de bloqueo de 8 vías', desc:'', videourl:'5013.mp4', zhsize:12, engsize:10, spsize:12, thum1:false, thum2:false},
							{id:3, title:'Placa del motor de 8 vías', desc:'', videourl:'5012.mp4', zhsize:13, engsize:0, spsize:12, thum1:false, thum2:false},
							{id:4, title:'Tablero de control de bloqueo de 12 vías', desc:'', videourl:'5014.mp4', zhsize:13, engsize:0, spsize:14, thum1:false, thum2:false},
							{id:5, title:'Tablero de control de bloqueo de 12 vías con luz', desc:'', videourl:'5014.mp4', zhsize:14, engsize:0, spsize:16, thum1:false, thum2:false},
							{id:6, title:'Tablero de control de bloqueo de 12 vías con límite positivo y negativo', desc:'', videourl:'5014.mp4', zhsize:15, engsize:0, spsize:15, thum1:false, thum2:false},
							{id:7, title:'Tablero de control de bloqueo de 15 vías', desc:'1', videourl:'5014.mp4', zhsize:12, engsize:0, spsize:0, thum1:false, thum2:false},
							{id:8, title:'Tablero de control de bloqueo de 18 vías', desc:'', videourl:'5018.mp4', zhsize:13, engsize:0, spsize:11, thum1:false, thum2:false},
							{id:9, title:'Panel de control de bloqueo de 25 vías con luz', desc:'', videourl:'5018.mp4', zhsize:15, engsize:0, spsize:11, thum1:false, thum2:false},
							{id:10, title:'Panel de control de bloqueo de 25 vías', desc:'', videourl:'5020.mp4', zhsize:12, engsize:0, spsize:15, thum1:false, thum2:false},
							{id:11, title:'Panel de control de bloqueo de 27 vías', desc:'', videourl:'5021.mp4', zhsize:15, engsize:0, spsize:16, thum1:false, thum2:false},
							{id:12, title:'Tablero de control de bloqueo de 50 vías', desc:'', videourl:'5022.mp4', zhsize:7, engsize:0, spsize:12, thum1:false, thum2:false},
							{id:13, title:'Tablero de control de bloqueo multifuncional', desc:'', videourl:'5023.mp4', zhsize:12, engsize:0, spsize:13, thum1:false, thum2:false},
							{id:14, title:'Tablero de control de relés', desc:'', videourl:'5024.mp4', zhsize:10, engsize:0, spsize:11, thum1:false, thum2:false},
							{id:15, title:'Placa de control de temperatura de 8 vías', desc:'', videourl:'5012.mp4', zhsize:10, engsize:0, spsize:9, thum1:false, thum2:false},
              {id:16, title:'tabla de pesaje de 25 posiciones', title1:'25路称重板', desc:'', videourl:'5026.mp4', zhsize:12, engsize:12, spsize:14, thum1:false, thum2:false},
              {id:17, title:'Tablero de control de cerradura de 36 vías', title1:'36路锁控板', desc:'', videourl:'5027.mp4', zhsize:15, engsize:15, spsize:13, thum1:false, thum2:false},
              {id:18, title:'Panel de control XYZ', title1:'XYZ控制板', desc:'', videourl:'5028.mp4', zhsize:13, engsize:12, spsize:11, thum1:false, thum2:false},
              {id:19, title:'tablero de carga', title1:'充电板', desc:'', videourl:'5029.mp4', zhsize:11, engsize:11, spsize:11, thum1:false, thum2:false},
              {id:20, title:'Cuadro de control electrico', title1:'电控板', desc:'', videourl:'5030.mp4', zhsize:15, engsize:15, spsize:14, thum1:false, thum2:false},
              {id:21, title:'Panel de control de pantalla', title1:'屏控板', desc:'', videourl:'5031.mp4', zhsize:13, engsize:13, spsize:0, thum1:false, thum2:false},
						]}
					]},
					{id:6, title:'Módulo de transmisión de datos', desc:'', size:4, children:[
						{id:1, title:'Módulo de transmisión de datos', desc:'', size:4, children:[
							{id:1, title:'4G DTU-5.3', desc:'4G DTU-3.0', videourl:'6011.mp4', zhsize:13, engsize:13, spsize:13, thum1:false, thum2:false},
							{id:2, title:'4G DTU-6.0', desc:'', videourl:'6012.mp4', zhsize:13, engsize:13, spsize:11, thum1:false, thum2:false},
							{id:3, title:'RJ45 DTU', desc:'', videourl:'6013.mp4', zhsize:8, engsize:7, spsize:10, thum1:false, thum2:false},
							{id:4, title:'WiFi DTU', desc:'', videourl:'6014.mp4', zhsize:8, engsize:8, spsize:9, thum1:false, thum2:false},
						]}
					]},
					{id:7, title:'Terminal de reconocimiento facial', desc:'', size:3, children:[
						{id:1, title:'Terminal de reconocimiento facial', desc:'', size:3, children:[
							{id:1, title:'Terminal de reconocimiento facial 7 "- tablet', desc:'7吋人脸识别终端-平板', videourl:'7011.mp4', zhsize:22, engsize:22, spsize:21, thum1:true, thum2:true},
							{id:2, title:'Terminal de reconocimiento facial 7 "- tablet', desc:'7吋人脸识别终端-圆柱', videourl:'7011.mp4', zhsize:19, engsize:19, spsize:18, thum1:false, thum2:false},
							{id:3, title:'Terminal de reconocimiento facial 8"', desc:'8吋人脸识别终端', videourl:'7011.mp4', zhsize:16, engsize:16, spsize:17, thum1:false, thum2:false},
						]}
					]},
				],
			}
		},
		created() {
			let _this = this;
			_this.proId = _this.$route.query.id;
			_this.proSeq = _this.$route.query.seq;
			_this.proIndex = _this.$route.query.index;
			// _this.pathName = _this.$route.query.name;
			// console.info(_this.prolist[_this.proId].lists[_this.proIndex].imglist);

			_this.jeeurl = window.gurl.SERVICE_CONTEXT_PATH;
			// console.info(_this.jeeurl);
			// console.info(_this.jeeurl);
			// console.info(_this.prolist[_this.proId].children[_this.proSeq].children[_this.proIndex].zhsize)
			// _this.currlist = _this.prolist[_this.proId].children[_this.proSeq].children[_this.proIndex].zhsize;
			// _this.hasThum1 = _this.prolist[_this.proId].children[_this.proSeq].children[_this.proIndex].thum1;
			// _this.hasThum2 = _this.prolist[_this.proId].children[_this.proSeq].children[_this.proIndex].thum2;

			_this.currlangs = _this.$route.query.queryLangs;
			console.info(_this.currlangs);
			if(_this.currlangs == 2) {
				_this.langs = sp;
				_this.langstype = 'sp';
				_this.prolist = _this.prolist3;
        let spsizes = _this.prolist3[_this.proId].children[_this.proSeq].children[_this.proIndex].spsize;
        let engsizes = _this.prolist3[_this.proId].children[_this.proSeq].children[_this.proIndex].engsizes;
				// console.info(_this.prolist);
				if(spsizes > 0) {
					_this.currlist = spsizes;
				} else if(spsizes==0 && engsizes>0) {
          _this.langstype = 'eng';
          _this.currlist = engsizes;
        } else {
					_this.langstype = 'zh';
					_this.currlist = _this.prolist1[_this.proId].children[_this.proSeq].children[_this.proIndex].zhsize;
				}
				// console.info(_this.currlist);
			} else if(_this.currlangs == 1) {
				_this.langs = eng;
				_this.langstype = 'eng';
				_this.prolist = _this.prolist2;
				let engsizes = _this.prolist2[_this.proId].children[_this.proSeq].children[_this.proIndex].engsize;
				// console.info(_this.prolist);
				if(engsizes > 0) {
					_this.currlist = engsizes;
				} else {
					_this.langstype = 'zh';
					_this.currlist = _this.prolist1[_this.proId].children[_this.proSeq].children[_this.proIndex].zhsize;
				}
				// console.info(_this.currlist);
			} else {
				_this.langs = zh;
				_this.langstype = 'zh';
				_this.prolist = _this.prolist1;
				_this.currlist = _this.prolist1[_this.proId].children[_this.proSeq].children[_this.proIndex].zhsize;
				// console.info(_this.currlist)
			}

			_this.pathName = _this.prolist[_this.proId].children[_this.proSeq].children[_this.proIndex].title;
			// console.info(_this.pathName)
			//_this.hasThum1 = _this.prolist[_this.proId].children[_this.proSeq].children[_this.proIndex].thum1;
			//_this.hasThum2 = _this.prolist[_this.proId].children[_this.proSeq].children[_this.proIndex].thum2;



			// console.info(_this.prolist[_this.proId].children[_this.proSeq].videourl)
			// console.info(_this.jeeurl+'Userfile/video/'+_this.langstype+'/'+_this.prolist[_this.proId][_this.proSeq].videourl);

			// console.info(_this.jeeurl+'Userfile/video/'+_this.langstype+'/'+_this.prolist[_this.proId].children[_this.proSeq].children[_this.proIndex].videourl);

			window.addEventListener("scroll", _this.handleScroll);

			setTimeout(() => {
				_this.showLoading = false;
			}, 500)
		},
		mounted() {
			let _this = this;
			_this.$nextTick(() => { // 在dom渲染完后,再执行动画
				var wow = new WOW({
					boxClass: 'wow',///动画元件css类（默认为wow）
					animateClass: 'animated',//动画css类（默认为animated）
					offset: 0,//到元素距离触发动画（当默认为0）
					mobile: true, //在移动设备上触发动画（默认为true）
					live: true//对异步加载的内容进行操作（默认为true）
				})
				wow.init();
			})
		},
		methods: {
			handleScroll() {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				// console.log(scrollTop)
				if(scrollTop>150){
					this.scrollNav = true;
				}else{
					this.scrollNav = false;
				}
			},
			clickSelectThum(index) {
				this.currThum = index;
			}
		}
	}
</script>

<style scoped>
	.curr-localtion{
		padding: 15px 0px 10px;
		border-bottom: 1px dashed #ccc;
	}
	.proScrollTop .curr-localtion{
		padding: 12px 20px;
	}
	.proScrollTop{
		position: fixed;
		top: 71px;
		width: 100%;
		max-width: 100%;
		background-color: #fff;
		z-index: 999999999;
		-webkit-animation: fadeInDown .3s;
		animation: fadeInDown .3s;
		box-shadow: 0px 5px 10px #999;
	}
	@keyframes fadeInDown{
		0% {
		  opacity: 0;
		  -webkit-transform: translateY(-20px);
		  transform: translateY(-20px);
		}
		100% {
		  opacity: 1;
		  -webkit-transform: translateY(0);
		  transform: translateY(0);
		}
	}
	.el-breadcrumb{
		font-size: 20px;
	}
	.pro-content{
		margin: 20px 0px 50px;
	}
	.pro-list{
		width: 1200px;
		margin: 0px auto;
		/* text-align: center; */
	}
	.list2{
		background-color: #eee;
		padding: 12px 0px;
	}
	.list2 .el-image{
		margin: 0px 12px;
	}
	.pro-list .el-image{
		overflow: unset;
	}
	.video-content{
		text-align: center;
	}
	.small-img{
		width: 80px;
		height: 80px;
		padding: 12px;
		border: 1px solid #999;
		margin-top: 10px;
		cursor: pointer;
	}
	.small-img.selectThum{
		border: 1px solid #f00;
	}
	.thumb-content{
		width:1200px;
		height:420px;
		margin:0px auto;
	}
	.thumb-content .el-image{
		overflow: hidden;
	}
	.pro-video{
		width:750px;
		height:420px;
		margin:0px auto;
	}
	@media screen and (max-width: 768px) {
		.curr-localtion{
			padding: 12px;
		}
		.proScrollTop{
			top: 69px;
		}
		.thumb-content{
			width:auto;
			height: auto;
			margin:0px auto;
		}
		.pro-video{
			width:375px;
			height:auto;
			margin:0px auto;
		}
		.pro-list{
			width: auto;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/prodetail.vue